import { lightFormat } from "date-fns/fp";
import * as React from "react";
import { BestShippingOption } from "../../types/product_availability/availability_types";
import { calculateDeliveryDate } from "./calculate_delivery_date";

type DeliveryDateProps = {
  bestShippingOption?: BestShippingOption | null;
  now?: Date;
};

export const DeliveryDate = ({
  bestShippingOption,
  now = new Date(),
}: DeliveryDateProps): JSX.Element => {
  if (bestShippingOption === null || bestShippingOption === undefined) {
    return (
      <div className="availability-state warning">Momentálně nedostupné</div>
    );
  }

  const expectedDeliveryDate = calculateDeliveryDate(bestShippingOption, now);
  const formattedDeliveryDate = lightFormat(
    "d. M.",
    expectedDeliveryDate.deliverOn
  );
  const tomorrow = new Date();
  tomorrow.setDate(new Date().getDate() + 1);
  return (
    <div className="availability-state in-stock">
      {"u vás doma "}
      {formattedDeliveryDate === lightFormat("d. M.", tomorrow)
        ? "zítra"
        : formattedDeliveryDate}
    </div>
  );
};
